module.exports = __webpack_public_path__ + "img/pocket-9_jp.8bd0f74.jpg";